import React from 'react'
import {
  NoResults,
  RPCDocs,
  usePaginationState,
  useReports,
} from '@therms/react-modules'
import { Loading, Pagination } from '@therms/atalaya'
import { ReportListCard } from '@src/modules/Reports/shared/ReportListCard'
import { generatePath, useHistory } from 'react-router-dom'
import { REPORTS_ROUTES } from '@src/modules/Reports/constants'
import { useUpdateEffect } from 'ahooks'
import { IoDocumentTextSharp } from 'react-icons/io5'

interface ReportsListProps {
  filters?: {
    activityTypeTagsFilter?: string[]
    authorUserIdsFilter?: string[]
    fromDate?: string
    toDate?: string
    refs?: string[]
    reportTypeIdsFilter?: string[]
    sort?: RPCDocs.Reports.GetReportsList.v1.Args['sort']
    state?: string[]
  }
  locationId: string
  searchText?: string
}

function ReportsList({filters, locationId, searchText}: ReportsListProps) {
  const {recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords} =
    usePaginationState('locreport', [])

  const history = useHistory()

  const {data, loading} = useReports({
    activityTypeTagsFilter: filters?.activityTypeTagsFilter,
    authorUserIdsFilter: filters?.authorUserIdsFilter,
    fromDate: filters?.fromDate,
    pagination: {limit: recordsPerPage, skip: skippedRecords},
    refs:
      filters?.refs && !!filters?.refs.length
        ? [locationId, ...filters.refs]
        : [locationId],
    reportTypeIdsFilter: filters?.reportTypeIdsFilter,
    searchText,
    sort: filters?.sort,
    state: filters?.state,
    toDate: filters?.toDate,
  })

  useUpdateEffect(() => {
    setSkippedRecords(0)
  }, [filters, searchText])

  return (
    <div>
      <Loading overlay visible={loading && !data?.reports?.length} />

      {data?.reports?.length ? (
        <div className="space-y-xs">
          {data?.reports?.map((report) => (
            <ReportListCard
              activityTypeTags={report.activityTypeTags}
              authors={report.authors}
              date={report.date}
              description={report.description}
              idLabel={report.idLabel}
              onClick={() =>
                history.push(
                  generatePath(REPORTS_ROUTES.VIEW_REPORT, {
                    reportId: report.id,
                  }),
                )
              }
              refsByType={report.refsByType}
              reportType={report.reportType}
              state={report.state}
              status={report.status}
              subTitle={report.subTitle}
              title={report.title}
              key={report.id}
            />
          ))}

          <div className="my-base">
            <Pagination
              onPageClick={setSkippedRecords}
              onSetRecordsPerPage={setRecordsPerPage}
              recordsPerPage={recordsPerPage}
              showDescription
              skippedRecords={skippedRecords}
              totalRecords={data?.total}
            />
          </div>
        </div>
      ) : (
        <NoResults iconName={IoDocumentTextSharp} text="No Reports" />
      )}
    </div>
  )
}

export {ReportsList}
